import { render, staticRenderFns } from "./ModelsList.vue?vue&type=template&id=7ffd192e&scoped=true&"
import script from "./ModelsList.vue?vue&type=script&lang=js&"
export * from "./ModelsList.vue?vue&type=script&lang=js&"
import style0 from "./ModelsList.vue?vue&type=style&index=0&id=7ffd192e&lang=scss&scoped=true&"
import style1 from "./ModelsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd192e",
  null
  
)

export default component.exports